import { renderContentPageHead } from '@redneckz/wildless-cms-uni-blocks/lib/components/ContentPage/renderContentPageHead';
import React from 'react';
import manifest from '../../content/wcms-resources/manifest.json';
import { ICONS } from '../icons';
import { isObjectLike } from '../utils/isObjectLike';

type MetaData = Record<string, any> | null;

interface MetaProps {
  yandexMetrikaId?: string;
  data: MetaData;
}

export const Meta = ({ yandexMetrikaId, data }: MetaProps) => {
  const yandexMetrikaIds = yandexMetrikaId?.split(',');
  const preparedData = prepareMetaData(data, ['site_name']);

  return (
    <>
      {renderContentPageHead(preparedData)}
      <link rel="manifest" href="/wcms-resources/manifest.json" />
      {ICONS ? ICONS.map((_, i) => <link key={String(i)} {..._} />) : null}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="msapplication-TileImage" content="/mstile-144x144.png" />
      <meta name="msapplication-TileColor" content="#42ab44" />
      <meta name="theme-color" content={manifest?.theme_color} />
      <meta name="msapplication-navbutton-color" content={manifest?.theme_color} />
      <meta name="apple-mobile-web-app-status-bar-style" content={manifest?.theme_color} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
              if (Boolean(navigator.userAgent.match(/.*Trident.*/))) {
                window.location.replace('/ie-warning.html')
              }`,
        }}
      ></script>
      <script src="https://api.mindbox.ru/scripts/v1/tracker.js" async></script>
      <script src="/mindbox_scripts.js" async></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
                mindbox.queue = mindbox.queue || [];
                mindbox('create', { endpointId: 'www.rshb.ru' })`,
        }}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                (function(e, x, pe, r, i, me, nt){
                e[i]=e[i]||function(){(e[i].a=e[i].a||[]).push(arguments)},
                me=x.createElement(pe),me.async=1,me.src=r,nt=x.getElementsByTagName(pe)[0],nt.parentNode.insertBefore(me,nt)})
                (window, document, 'script', 'https://abt.s3.yandex.net/expjs/latest/exp.js', 'ymab');
                ymab('metrika.91032997', 'init'/*, {clientFeatures}, {callback}*/);`,
        }}
      />

      {yandexMetrikaIds ? (
        <>
          <link rel="dns-prefetch" href="//yandex.ru/" />
          <link rel="preconnect" href="https://mc.yandex.ru/" />
          <script
            dangerouslySetInnerHTML={{
              __html: yandexScripts(yandexMetrikaIds),
            }}
          />
        </>
      ) : null}
    </>
  );
};

export const YandexMetrika = ({ yandexMetrikaId }: { yandexMetrikaId?: string }) => {
  const yandexMetrikaIds = yandexMetrikaId?.split(',');

  return yandexMetrikaIds ? (
    <noscript>
      <div>
        {yandexMetrikaIds.map((_) => (
          <img
            key={String(_)}
            src={`https://mc.yandex.ru/watch/${_}`}
            style={{ position: 'absolute', left: '-9999px' }}
            alt=""
          />
        ))}
      </div>
    </noscript>
  ) : null;
};

const yandexScripts = (yandexMetrikaIds?: string[]) => {
  const ymScripts = yandexMetrikaIds?.map(
    (_) => `ym(${_}, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true,
      trackHash:true
    })`,
  );

  return `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    ${ymScripts?.join(';')}`;
};

const prepareMetaData = (data: MetaData, exclude: string[] = []) =>
  Object.fromEntries(
    Object.entries(data ?? {})
      .filter(([, value]) => (Array.isArray(value) ? value.length : Boolean(value)))
      .map(([key, value]): [string, any] => [
        exclude.includes(key) ? key : key.replace('_', ':'),
        isObjectLike(value) ? prepareMetaData(value as MetaData, exclude) : value,
      ]),
  );
